@@include("vendors/greensock/minified/plugins/TextPlugin.min.js");
@@include("vendors/greensock/minified/plugins/ScrollToPlugin.min.js");
// DELETE
// BEFORE PRODUCTION
@@include("vendors/Scrollmagic/minified/plugins/debug.addIndicators.min.js");

document.addEventListener('gesturestart', function (e) {
    e.preventDefault();
});

// Controller
var controller = new ScrollMagic.Controller();

var windowsPC = new RegExp('Windows NT');
var chromeOS = new RegExp('CrOS');

if ( $('html').hasClass('no-touchevents') || windowsPC.test(navigator.userAgent) || chromeOS.test(navigator.userAgent) ) { //on non-touch devices, animations enabled

  $('.hero').css('opacity',0);
  // hero animation timeline
  var tlHero = new TimelineLite();

  // hero animation
  $(document).ready(function(){
    tlHero.fromTo('.hero',1,
    {opacity: 0, backgroundPositionX: '20%'},
    {opacity: 1, backgroundPositionX: '30%'});
  });

  @@include("components/tldr/intro.js");
  @@include("components/tldr/grey.js");
  @@include("components/tldr/chat-header.js");
  @@include("components/tldr/chat.js");
  @@include("components/tldr/black.js");
  @@include("components/tldr/solution-1.js");
  @@include("components/tldr/solution-2.js");
  @@include("components/tldr/solution-3.js");
  @@include("components/tldr/solution-4.js");
  @@include("components/tldr/solution-5.js");
  @@include("components/tldr/end-yellow.js");
  @@include("components/tldr/conclusion.js");
  @@include("components/tldr/conclusion.js");
  @@include("components/tldr/smooth-scroll.js");

  $('[data-stagger-up]').css('opacity',0);  

} else { //on touch devices, only chat animations enabled
  @@include("components/tldr/chat.js");
  @@include("components/tldr/conclusion.js");
  @@include("components/tldr/smooth-scroll.js");
};